export default  {
  description: 'node equivalent to a building storey',
  params: {},
  childrenTypes: [
    'box',
    'closet',
    'column',
    'curtain',
    'floor',
    'floorplan',
    'group',
    'interior',
    'kitchen',
    'object',
    'polybox',
    'polyfloor',
    'railing',
    'stairs',
    'tag',
    'wall'
  ],
  parentTypes: ['plan']
}
